<template>
  <div
    class="content-layout d-block bg-dashboard p-5 text-primary overflow-auto"
  >
    <!-- <div class="px-3 pb-3 text-right">
      <div class="dropdown">
        <button
          class="btn btn-primary dropdown-toggle btn-sm text-uppercase"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <font-awesome-icon class="mr-2" :icon="['fas', 'clipboard-list']" />
          {{ dataType }} Inspections
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" href="#" @click.prevent="switchDataType()">
            {{ dataType == "normal" ? "VO Inspections" : "Normal Inspections" }}
          </a>
        </div>
      </div>
    </div>-->
    <div class="px-3 pb-3 text-right">
      <div class="dropdown">
        <button
          class="btn btn-primary dropdown-toggle btn-sm text-uppercase shadow-sm"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          :disabled="user && user.district.length > 0"
        >
          <font-awesome-icon class="mr-2" :icon="['fas', 'clipboard-list']" />
          {{ models.district ? models.district.name : "All District" }}
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a
            class="dropdown-item"
            href="#"
            @click.prevent="switchDistrict('All')"
            >All District</a
          >
          <a
            v-for="district in districtOptions"
            :key="district._id"
            class="dropdown-item"
            href="#"
            @click.prevent="switchDistrict(district._id)"
            >{{ district.name }}</a
          >
        </div>
      </div>
    </div>
    <div class="row mx-0">
      <div class="col-12 col-md-7">
        <div class="card shadow">
          <div class="card-body">
            <p class="card-title font-weight-bold">NO OF POLES INSPECTED</p>
            <div class="progress">
              <div
                class="progress-bar"
                role="progressbar"
                :style="`width: ${(polesInspected / 3340) * 100}%`"
                :aria-valuenow="(polesInspected / 3340) * 100"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <h4 class="text-center mb-0 mt-3 text-primary">
              {{ polesInspected }}/3340
            </h4>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-5 px-0 pt-4 pt-md-0">
        <div class="row m-0 h-100">
          <div class="col-6">
            <div class="card shadow h-100">
              <div
                class="card-body d-flex justify-content-center align-items-center flex-column"
              >
                <p class="card-title font-weight-bold text-nowrap">
                  TOTAL POLES
                </p>
                <h1 class="card-title mb-0 font-weight-bold text-primary">
                  3340
                </h1>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card shadow h-100">
              <div
                class="card-body d-flex justify-content-center align-items-center flex-column"
              >
                <p class="card-title font-weight-bold text-nowrap">
                  TOTAL DEFECTS
                </p>
                <h1 class="card-title mb-0 font-weight-bold text-primary">
                  {{ totalDefects }}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mx-0">
      <div class="col-12 col-md-6 pt-4">
        <div class="card shadow h-100">
          <div class="card-body position-relative w-100 h-100">
            <p class="card-title font-weight-bold align-self-start">
              INSPECTED POLES THIS WEEK
              <span class="font-weight-normal text-muted small float-right">
                {{ moment(thisWeek.start).format("DD/MM/YYYY") }} to
                {{ moment(thisWeek.end).format("DD/MM/YYYY") }}
              </span>
            </p>
            <div class="w-100" style="height: 200px">
              <line-chart
                class="w-100 h-100"
                v-if="chartData.polesThisWeek"
                :chart-data="chartData.polesThisWeek"
                :options="chartOptions.line"
              ></line-chart>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 pt-4">
        <div class="card shadow h-100">
          <div class="card-body position-relative w-100 h-100">
            <p class="card-title font-weight-bold align-self-start">
              INSPECTED DEFECTS THIS WEEK
              <span class="font-weight-normal text-muted small float-right">
                {{ moment(thisWeek.start).format("DD/MM/YYYY") }} to
                {{ moment(thisWeek.end).format("DD/MM/YYYY") }}
              </span>
            </p>
            <div class="w-100" style="height: 200px">
              <line-chart
                class="w-100 h-100"
                v-if="chartData.defectsThisWeek"
                :chart-data="chartData.defectsThisWeek"
                :options="chartOptions.line"
              ></line-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mx-0">
      <div class="col-12 col-sm-6 col-md-3 pt-4">
        <div class="card shadow h-100">
          <div class="card-body position-relative w-100 h-100">
            <p class="card-title font-weight-bold align-self-start">
              DEFECT SEVERITY
            </p>
            <div class="w-100" style="height: 200px">
              <pie-chart
                class="w-100 h-100"
                v-if="chartData.defectSeverity"
                :chart-data="chartData.defectSeverity"
                :options="chartOptions.pie"
              ></pie-chart>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 pt-4">
        <div class="card shadow h-100">
          <div class="card-body position-relative w-100 h-100">
            <p class="card-title font-weight-bold align-self-start">
              DEFECT TYPE
            </p>
            <div class="w-100" style="height: 200px">
              <pie-chart
                class="w-100 h-100"
                v-if="chartData.defectType"
                :chart-data="chartData.defectType"
                :options="chartOptions.pie"
              ></pie-chart>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 pt-4">
        <div class="card shadow h-100" style="background-color: #2e2854">
          <div class="card-body position-relative w-100 h-100">
            <p class="card-title font-weight-bold align-self-start text-white">
              VISUAL MAINTENANCE
            </p>
            <div class="w-100" style="height: 200px">
              <bar-group-chart
                class="w-100 h-100"
                v-if="chartData.maintenanceVisual"
                :chart-data="chartData.maintenanceVisual"
                :options="chartOptions.barGroup"
              ></bar-group-chart>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 pt-4">
        <div class="card shadow h-100" style="background-color: #223140">
          <div class="card-body position-relative w-100 h-100">
            <p class="card-title font-weight-bold align-self-start text-white">
              THERMAL MAINTENANCE
            </p>
            <div class="w-100" style="height: 200px">
              <bar-group-chart
                class="w-100 h-100"
                v-if="chartData.maintenanceThermal"
                :chart-data="chartData.maintenanceThermal"
                :options="chartOptions.barGroup"
              ></bar-group-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import Moment from "moment";
import LineChart from "@/components/LineChart";
import PieChart from "@/components/PieChart";
import BarGroupChart from "@/components/BarGroupChart";

export default {
  name: "dashboard",
  components: {
    LineChart,
    PieChart,
    BarGroupChart,
  },
  data() {
    return {
      dataType: "normal",
      moment: Moment,
      thisWeek: {
        start: null,
        end: null,
      },
      polesInspected: 0,
      totalDefects: 0,
      chartData: {
        polesThisWeek: null,
        defectsThisWeek: null,
        defectSeverity: null,
        defectType: null,
        maintenanceVisual: null,
        maintenanceThermal: null,
      },
      dataCollection: null,
      chartOptions: {
        barGroup: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: true,
            position: "bottom",
            align: "start",
            labels: {
              usePointStyle: true,
              boxWidth: 8,
              fontColor: "#ffffff",
              fontSize: 11,
            },
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  fontColor: "#ffffff",
                  fontSize: 10,
                  beginAtZero: true,
                  min: 0,
                  stepSize: 1,
                },
                gridLines: {
                  color: "#324151",
                },
              },
            ],
            xAxes: [
              {
                ticks: {
                  fontColor: "#ffffff",
                  fontSize: 10,
                  beginAtZero: true,
                  min: 0,
                  stepSize: 1,
                },
                gridLines: {
                  color: "#324151",
                },
              },
            ],
          },
        },
        line: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  min: 0,
                  stepSize: 1,
                  beginAtZero: true,
                },
              },
            ],
          },
        },
        pie: {
          plugins: {
            datalabels: {
              color: "#FFFFFF",
              font: {
                weight: "bold",
              },
              backgroundColor: "#365975",
              padding: {
                left: 10,
                right: 10,
              },
              borderRadius: 10,
            },
          },
          responsive: true,
          maintainAspectRatio: false,
          pointStyle: "circle",
          legend: {
            display: true,
            position: "left",
            align: "start",
            labels: {
              usePointStyle: true,
              boxWidth: 12,
            },
          },
        },
      },
      models: {
        district: null,
      },
      districtOptions: [],
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
  methods: {
    switchDistrict(id) {
      if (id == "All") {
        this.models.district = null;
      } else {
        this.models.district = this.districtOptions.find((d) => d._id == id);
      }

      this.getPoles();
    },
    switchDataType() {
      if (this.dataType == "normal") {
        this.dataType = "vo";
      } else {
        this.dataType = "normal";
      }

      this.getPoles();
    },
    fillData(
      defectSeverity,
      defectType,
      ptw,
      dtw,
      maintenanceVisual,
      maintenanceThermal
    ) {
      this.chartData.polesThisWeek = {
        labels: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        datasets: [
          {
            label: "Poles",
            borderColor: "#A5CEE2",
            backgroundColor: "#A5CEE2",
            pointBackgroundColor: "#A5CEE2",
            lineTension: 0.3,
            pointRadius: 5,
            fill: false,
            data: ptw,
          },
        ],
      };

      this.chartData.defectsThisWeek = {
        labels: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        datasets: [
          {
            label: "Defects",
            borderColor: "#FDCD3C",
            backgroundColor: "#FDCD3C",
            pointBackgroundColor: "#FDCD3C",
            lineTension: 0.3,
            pointRadius: 5,
            fill: false,
            data: dtw,
          },
        ],
      };

      this.chartData.defectSeverity = {
        labels: ["Low", "Minor", "Critical"],
        datasets: [
          {
            label: "Severity",
            backgroundColor: ["#6DBDE8", "#FDCD3C", "#EE656C"],
            data: defectSeverity,
          },
        ],
      };

      this.chartData.defectType = {
        labels: ["Visual", "Thermal"],
        datasets: [
          {
            label: "Type",
            backgroundColor: ["#6DBDE8", "#EE656C"],
            data: defectType,
          },
        ],
      };

      this.chartData.maintenanceVisual = {
        labels: ["Low", "Minor", "Critical"],
        datasets: maintenanceVisual.map((mv, index) => {
          return {
            label: index == 0 ? "Total" : "Repaired",
            backgroundColor: index == 0 ? "#DE6D70" : "#97E59F",
            data: mv,
          };
        }),
      };

      this.chartData.maintenanceThermal = {
        labels: ["Low", "Minor", "Critical"],
        datasets: maintenanceThermal.map((mt, index) => {
          return {
            label: index == 0 ? "Total" : "Repaired",
            backgroundColor: index == 0 ? "#DE6D70" : "#97E59F",
            data: mt,
          };
        }),
      };
    },
    async getDistricts() {
      this.$emit("isLoading", true);

      API.get("places?_limit=-1&type=District&place.name=Sabah").then(
        (retVal) => {
          this.districtOptions = retVal.data;

          if (
            this.districtOptions.length > 0 &&
            this.user.district.length > 0
          ) {
            let userDistrict = this.districtOptions.find(
              (d) => d.name.toLowerCase() == this.user.district.toLowerCase()
            );

            this.models.district = userDistrict;
          }

          this.getPoles();
        }
      );
    },
    async getPoles() {
      this.$emit("isLoading", true);

      let url = "dashboard";

      if (this.models.district) {
        url += `/${this.models.district._id}`;
      }

      API.get(url)
        .then((retVal) => {
          this.polesInspected = retVal.data.poleCount;

          this.totalDefects = retVal.data.defectCount;

          this.fillData(
            retVal.data.severity,
            retVal.data.type,
            retVal.data.ptw.map((p) => p.value),
            retVal.data.dtw.map((d) => d.value),
            retVal.data.maintenanceVisual,
            retVal.data.maintenanceThermal
          );

          this.$emit("isLoading", false);
        })
        .catch((err) => {
          console.error(err);
          this.$emit("isLoading", false);
        });
    },
  },
  async mounted() {
    this.thisWeek.start = Moment().startOf("isoWeek").startOf("day");
    this.thisWeek.end = Moment().endOf("isoWeek").endOf("day");

    await this.getDistricts();
  },
};
</script>
